import { render } from "./EntitySelectorArtEngenheiroTransportador.vue?vue&type=template&id=7dd633da"
import script from "./EntitySelectorArtEngenheiroTransportador.vue?vue&type=script&lang=ts"
export * from "./EntitySelectorArtEngenheiroTransportador.vue?vue&type=script&lang=ts"
script.render = render

export default script